import api from '@/http/api'
import ExploreCatalog, { type ExploreCatalogParams } from '@univdiam/ui/customComponents/Catalog/ExploreCatalog'
import { useNavigate } from 'react-router-dom'

const fetchCatalog = (params: ExploreCatalogParams) =>
  api.get('/catalog/', { params }).then(res => res.data)

function Catalog() {
  const navigate = useNavigate()
  const handleNavigate = (sku: string) => {
    navigate(`/catalog-product/${sku}`)
  }

  return (
    <div>
      <ExploreCatalog handleNavigate={handleNavigate} fetchCatalog={fetchCatalog} />
    </div>
  )
}

export default Catalog
